import type React from "react";

interface DiscordLogoProps {
  width?: number;
  height?: number;
  className?: string;
}

export const DiscordLogo: React.FC<DiscordLogoProps> = ({
  width = 20,
  height = 20,
  className = "w-5 h-5",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
      className={className}
      aria-label="Discord logo"
    >
      <title>Discord logo</title>
      <path
        d="M52.3632 10.9284C48.5656 9.15159 44.5051 7.86028 40.2598 7.125C39.7385 8.0676 39.1294 9.33543 38.7094 10.344C34.1967 9.66531 29.7254 9.66531 25.2956 10.344C24.8757 9.33543 24.2528 8.0676 23.7268 7.125C19.477 7.86028 15.4117 9.15633 11.6141 10.9378C3.95434 22.5127 1.8779 33.8002 2.91612 44.9273C7.9965 48.7212 12.92 51.0259 17.7604 52.534C18.9555 50.8892 20.0214 49.1407 20.9396 47.298C19.1908 46.6335 17.5158 45.8134 15.9332 44.8614C16.353 44.5503 16.7638 44.2251 17.1605 43.8905C26.8137 48.4055 37.3021 48.4055 46.8399 43.8905C47.2414 44.2251 47.652 44.5503 48.0673 44.8614C46.4799 45.8181 44.8004 46.6381 43.0516 47.3027C43.9698 49.1407 45.0311 50.894 46.2308 52.5387C51.0759 51.0306 56.0039 48.726 61.0843 44.9273C62.3025 32.0281 59.0033 20.8443 52.3632 10.9284ZM22.2548 38.0842C19.357 38.0842 16.9806 35.379 16.9806 32.0847C16.9806 28.7903 19.3062 26.0804 22.2548 26.0804C25.2034 26.0804 27.5797 28.7856 27.5289 32.0847C27.5335 35.379 25.2034 38.0842 22.2548 38.0842ZM41.7457 38.0842C38.8479 38.0842 36.4715 35.379 36.4715 32.0847C36.4715 28.7903 38.7971 26.0804 41.7457 26.0804C44.6942 26.0804 47.0706 28.7856 47.0199 32.0847C47.0199 35.379 44.6942 38.0842 41.7457 38.0842Z"
        fill="currentColor"
      />
    </svg>
  );
};
